export enum AgendaType {
  SESSION = 1,
  ONDEMAND = 2,
  BOTH = 12,
}

export enum Resource {
  URL = 1,
  PDF = 2,
}

export enum MediaType {
  YOUTUBE = 'yt',
  VIMEO = 'vimeo',
  ZOOM = 'zoom',
  RTMP = 'rtmp',
  BLUEJEANS = 'bj',
  OTHER = 'other',
}
